import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import Select from 'react-select';
import measureOptions from '../../../../helpers/measureOptions.json';
import { completeOrAssuredRequest } from '../../../../helpers/completeOrAssuredRequest';

export const ConfirmModal = ({confirmModal, setConfirmModal, summaryData, cmosUserInput, meterUserInput, setSummaryData, prefix, suffix = "", displayModuleIssues}) => {
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [selectedMeasureOptions, setSelectedMeasureOptions] = useState({
    UPRN: {},
    VOA: {},
    ADDRESS: {}
  })
  const [comments, setComments] = useState({
    UPRN: '',
    VOA: ''
  })
  const submitAssuredDisabled = () => {
    if ((selectedMeasureOptions.UPRN.commentBox && comments.UPRN.length < 1) || (selectedMeasureOptions.VOA.commentBox && comments.VOA.length < 1)) {
      return true
    } else if (Object.values(selectedMeasureOptions).every(option => !option.value)) {
      return true
    } else {
      return false
    }
  }
  const cancelAssured = () => {
    setConfirmModal(false)
    setSelectedMeasureOptions({UPRN: {}, VOA: {}, ADDRESS: {}})
    setComments({UPRN: '', VOA: ''})
  }
  useEffect(() => {
    if (comments.UPRN && !selectedMeasureOptions.UPRN.commentBox) {
      setComments({...comments, UPRN: ''})
    }
    if (comments.VOA && !selectedMeasureOptions.VOA.commentBox) {
      setComments({...comments, VOA: ''})
    }
  }, [selectedMeasureOptions.UPRN, selectedMeasureOptions.VOA])

  if (confirmModal === "Assured") {
    return (
      <ReactModal 
      isOpen={confirmModal} 
      onRequestClose={() => cancelAssured()}
      className="card bulk-allocate"
      contentLabel="Wholesaler GAPs No Match"
      style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' }, content: { width: '35vw' } }}>
        <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
          <h3 style={{ margin: '0px' }}>Confirm</h3>
          <p>Please select measure options:</p>
          <table className="table borders squish" style={{ marginBottom: '5px' }}>
            <thead>
              <tr>
                <th style={{ width: '10em' }}>Measure</th>
                <th>Explanation</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Address</td>
                <td style={{ textAlign: 'left', color: 'black' }}>
                  <Select options={measureOptions.address_options} value={selectedMeasureOptions.ADDRESS} onChange={(choice) => setSelectedMeasureOptions({...selectedMeasureOptions, ADDRESS: choice})} />
                </td>
              </tr>
              <tr>
                <td>UPRN</td>
                <td style={{ textAlign: 'left', color: 'black' }}>
                  <Select options={measureOptions.uprn_options} value={selectedMeasureOptions.UPRN} onChange={(choice) => setSelectedMeasureOptions({...selectedMeasureOptions, UPRN: choice})} />
                </td>
              </tr>
              <tr>
                <td>VOA</td>
                <td style={{ textAlign: 'left', color: 'black' }}>
                  <Select options={measureOptions.voa_options} value={selectedMeasureOptions.VOA} onChange={(choice) => setSelectedMeasureOptions({...selectedMeasureOptions, VOA: choice})} />
                </td>
              </tr>
            </tbody>
          </table>
          {/* No option in measureOptions.json currently has commentBox: true, so this never renders today. Left in place in case a commentBox option is reintroduced. */}
          { ['UPRN', 'VOA'].map((type) => {
            const reducedRows = selectedMeasureOptions.UPRN.commentBox && selectedMeasureOptions.VOA.commentBox
            return (
              selectedMeasureOptions[type].commentBox && 
                <div>
                  <label>{type} Comment:</label>
                  <textarea onChange={(event) => setComments({...comments, [type]: event.target.value.slice(0, 500)})} value={comments[type] ?? ''} rows={reducedRows ? 6 : 8} style={{height: '100%', width: '100%', resize: 'none'}}/>  
                  <div style={{ position: 'relative', bottom: '3px', textAlign: 'end', color: 'gray', fontSize: 12 }}>
                    {comments[type].length}/500
                  </div>
                </div>
            )
          })}
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
            <button className="button compact smaller-text cancel" onClick={ () => cancelAssured() }>Cancel</button>
            <button className={`button compact smaller-text ${!submitAssuredDisabled() ? "background-primary colour-white" : ''}`}
            disabled={submitAssuredDisabled()}
            onClick={() => completeOrAssuredRequest(setLoadingConfirm, prefix, suffix, summaryData, confirmModal, cmosUserInput, meterUserInput, selectedMeasureOptions, comments, setSummaryData, cancelAssured, displayModuleIssues )}
            >
              { !loadingConfirm ?
                  "Confirm"
                :
                  <div className="spinner" style={{ margin: '0em 1em' }}>
                    <i className="fa fa-spinner fa-spin"></i>
                  </div>
              }
            </button> 
          </div>
        </div>
      </ReactModal>
    )
  } else {
    return (
      <ReactModal 
      isOpen={confirmModal} 
      onRequestClose={() => setConfirmModal(false)}
      className="card bulk-allocate"
      contentLabel="Wholesaler GAPs No Match"
      style={{ overlay: { backgroundColor: 'rgba(14, 14, 14, 0.55)' } }}>
        <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
          <h3>Confirm</h3>
          { confirmModal === "Reject" ?
            <p>Please confirm you wish to reject these changes.</p>
          : confirmModal === "Quality Check Passed" ?
            <p>Please confirm you wish to pass these changes.</p>
          :
            <p>Please confirm you are finished working on this SPID.</p>
          }
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
            <button className="button compact smaller-text cancel" onClick={ () => setConfirmModal(false) }>Cancel</button>
            <button className="button compact smaller-text background-primary colour-white" disabled={loadingConfirm} onClick={() => completeOrAssuredRequest(setLoadingConfirm, prefix, suffix, summaryData, confirmModal, cmosUserInput, meterUserInput, null, null, setSummaryData, () => setConfirmModal(false), displayModuleIssues)} >
              { !loadingConfirm ?
                  "Confirm"
                :
                  <div className="spinner" style={{ margin: '0em 1em' }}>
                    <i className="fa fa-spinner fa-spin"></i>
                  </div>
              }
            </button> 
          </div>
        </div>
      </ReactModal>
    )
  }
}